// import { useMutation }        from '@apollo/client'
// import { FIX_LOCATIONS }      from '../../graphql/document'
import { ArrowUturnLeftIcon } from '@heroicons/react/24/solid'
import { useState }           from 'react'
import { useSelector }        from 'react-redux'
import { useNavigate }        from 'react-router-dom'
import { Button }             from '../../components'
import { LoadingEllipsis }    from '../../components/Loaders'
import SettingsGeneralTab     from '../../components/Settings/GeneralSettings/SettingsGeneralTab'
import SettingsForumTab       from '../../components/Settings/ForumSettings/SettingsForumTab'
import SettingsShopTab        from '../../components/Settings/ShopSettings/SettingsShopTab'
import SettingsUsersTab       from '../../components/Settings/UsersSettings/SettingsUsersTab'
import MainLayout             from '../../layouts/MainLayout'

export default function Settings(): JSX.Element {
  const currentUser: any            = useSelector( ( state: any ): any => state.currentUser.user )
  const navigate: any               = useNavigate()
  const [ activeTab, setActiveTab ] = useState( 'general' )
  const modules: string[]           = [ 'general', 'users', 'forum' ]

  const navStyle: string = 'w-full h-full px-3 py-1 flex items-center whitespace-nowrap justify-center bg-blue-secondary'

  // const [ updateLocDoc, { loading: updatingLocDoc } ] = useMutation( FIX_LOCATIONS, {
  //   variables:   { input: { email: currentUser?.email } },
  //   onCompleted: ( data ): void => {
  //     console.log( 'updateLocDoc end ', data )
  //   },
  //   onError:     ( error: any ): void => console.log( error )
  // } )

  return (
    <MainLayout>
      <div className="max-w-screen-3xl mx-auto w-full">
        <div className="flex-grow lg:p-8 p-3 space-y-4 lg:space-y-8">
          { !currentUser && <LoadingEllipsis klass="ellipse-yellow ellipse-xl p-4 mt-4 w-full" /> }

          {/*{*/ }
          {/*  currentUser?.email === 'dawid@denfield.co.uk' &&*/ }
          {/*  <Button yellow label="Update" loading={ updatingLocDoc } onClick={ updateLocDoc } />*/ }
          {/*}*/ }

          { currentUser?.admin &&
            <>
              <div className="flex justify-between w-full my-4">
                <div className="flex rounded-full text-sm font-medium text-white overflow-hidden">
                  <Button
                    label="Back"
                    blue
                    onClick={ (): any => navigate( -1 ) }
                    icon={ <ArrowUturnLeftIcon className="w-4 h-4" /> }
                  />
                </div>
                <div className="flex rounded-full text-sm font-medium text-white overflow-hidden">
                  { modules.map( ( module: string, index: number ): any => (
                    <button
                      className={ navStyle }
                      onClick={ (): void => setActiveTab( module ) }
                      key={ index }
                    >
                      <span className="capitalize">{ module }</span>
                    </button> ) ) }
                </div>
              </div>

              <div className="row flex flex-col items-center w-full bg-white rounded-3xl p-3 xl:p-4">
                { ( activeTab === 'general' ) && <SettingsGeneralTab /> }
                { ( activeTab === 'users' ) && <SettingsUsersTab /> }
                { ( activeTab === 'forum' ) && <SettingsForumTab /> }
                { ( activeTab === 'shop' ) && <SettingsShopTab /> }
              </div>
            </>
          }
          { !currentUser?.admin &&
            <div className="row flex flex-col items-center w-full bg-white rounded-3xl p-3 xl:p-4">
              Access Denied!
            </div>
          }
        </div>
      </div>
    </MainLayout>
  )
}
